import { isObject as i } from "./index68.js";
const p = (s, e) => s.replace(/{(\w+)}/g, (t, a) => {
  let r;
  if (Array.isArray(e))
    r = e[a];
  else if (i(e)) {
    const c = t.replace(/[{}]/g, "");
    r = e[c];
  }
  return r ?? "";
});
export {
  p as parseResourceText
};
